{
  "abi": [
    {
      "type": "constructor",
      "inputs": [
        {
          "name": "_registry",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "_superPaymaster",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "_dvtValidator",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "DVT_VALIDATOR",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "MAX_VALIDATORS",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "REGISTRY",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "contract IRegistry"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "SLASH_THRESHOLD_FLOOR",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint8",
          "internalType": "uint8"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "SUPERPAYMASTER",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "aggregatedSignatures",
      "inputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [
        {
          "name": "aggregatedSig",
          "type": "bytes",
          "internalType": "bytes"
        },
        {
          "name": "messageHash",
          "type": "bytes32",
          "internalType": "bytes32"
        },
        {
          "name": "timestamp",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "verified",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "defaultThreshold",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "executeGuardianSlash",
      "inputs": [
        {
          "name": "fraudProofId",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "guiltyGuardians",
          "type": "address[]",
          "internalType": "address[]"
        },
        {
          "name": "fraudProof",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "executeProposal",
      "inputs": [
        {
          "name": "proposalId",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "target",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "callData",
          "type": "bytes",
          "internalType": "bytes"
        },
        {
          "name": "requiredThreshold",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "proof",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "executedProposals",
      "inputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "fraudProofVerifier",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getBLSPublicKey",
      "inputs": [
        {
          "name": "validator",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "publicKey",
          "type": "tuple",
          "internalType": "struct BLS.G1Point",
          "components": [
            {
              "name": "x_a",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "x_b",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "y_a",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "y_b",
              "type": "bytes32",
              "internalType": "bytes32"
            }
          ]
        },
        {
          "name": "slot",
          "type": "uint8",
          "internalType": "uint8"
        },
        {
          "name": "isActive",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "guardianSlashed",
      "inputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "minThreshold",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "owner",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "permissionlessBLSRegistration",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "proposalNonces",
      "inputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "proposalSignersCommitment",
      "inputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bytes32",
          "internalType": "bytes32"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "queueSlashWithConsensus",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "slashLevel",
          "type": "uint8",
          "internalType": "uint8"
        },
        {
          "name": "epoch",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "proof",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "registerBLSPublicKey",
      "inputs": [
        {
          "name": "validator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "publicKey",
          "type": "tuple",
          "internalType": "struct BLS.G1Point",
          "components": [
            {
              "name": "x_a",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "x_b",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "y_a",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "y_b",
              "type": "bytes32",
              "internalType": "bytes32"
            }
          ]
        },
        {
          "name": "slot",
          "type": "uint8",
          "internalType": "uint8"
        },
        {
          "name": "popSignature",
          "type": "tuple",
          "internalType": "struct BLS.G2Point",
          "components": [
            {
              "name": "x_c0_a",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "x_c0_b",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "x_c1_a",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "x_c1_b",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "y_c0_a",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "y_c0_b",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "y_c1_a",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "y_c1_b",
              "type": "bytes32",
              "internalType": "bytes32"
            }
          ]
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "renounceOwnership",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "revokeBLSPublicKey",
      "inputs": [
        {
          "name": "validator",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setDVTValidator",
      "inputs": [
        {
          "name": "_dv",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setDefaultThreshold",
      "inputs": [
        {
          "name": "_newThreshold",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setFraudProofVerifier",
      "inputs": [
        {
          "name": "verifier",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setMinThreshold",
      "inputs": [
        {
          "name": "_newThreshold",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setPermissionlessBLSRegistration",
      "inputs": [
        {
          "name": "enabled",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setSlashPolicyAdmin",
      "inputs": [
        {
          "name": "newAdmin",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setSlashThreshold",
      "inputs": [
        {
          "name": "slashLevel",
          "type": "uint8",
          "internalType": "uint8"
        },
        {
          "name": "threshold",
          "type": "uint8",
          "internalType": "uint8"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setSuperPaymaster",
      "inputs": [
        {
          "name": "_sp",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "slashPolicyAdmin",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "slashThresholds",
      "inputs": [
        {
          "name": "",
          "type": "uint8",
          "internalType": "uint8"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "uint8",
          "internalType": "uint8"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "transferOwnership",
      "inputs": [
        {
          "name": "newOwner",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "usedSlashQueueHashes",
      "inputs": [
        {
          "name": "",
          "type": "bytes32",
          "internalType": "bytes32"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "validatorAtSlot",
      "inputs": [
        {
          "name": "",
          "type": "uint8",
          "internalType": "uint8"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "verify",
      "inputs": [
        {
          "name": "expectedMessageHash",
          "type": "bytes32",
          "internalType": "bytes32"
        },
        {
          "name": "signerMask",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "requiredThreshold",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "sigBytes",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "verifyAndExecute",
      "inputs": [
        {
          "name": "proposalId",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "slashLevel",
          "type": "uint8",
          "internalType": "uint8"
        },
        {
          "name": "repUsers",
          "type": "address[]",
          "internalType": "address[]"
        },
        {
          "name": "newScores",
          "type": "uint256[]",
          "internalType": "uint256[]"
        },
        {
          "name": "epoch",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "evidenceHash",
          "type": "bytes32",
          "internalType": "bytes32"
        },
        {
          "name": "proof",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "version",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "stateMutability": "pure"
    },
    {
      "type": "event",
      "name": "BLSPublicKeyRegistered",
      "inputs": [
        {
          "name": "validator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "slot",
          "type": "uint8",
          "indexed": true,
          "internalType": "uint8"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "BLSPublicKeyRevoked",
      "inputs": [
        {
          "name": "validator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "slot",
          "type": "uint8",
          "indexed": true,
          "internalType": "uint8"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "BLSVerificationStatus",
      "inputs": [
        {
          "name": "proposalId",
          "type": "uint256",
          "indexed": true,
          "internalType": "uint256"
        },
        {
          "name": "success",
          "type": "bool",
          "indexed": false,
          "internalType": "bool"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "DVTValidatorUpdated",
      "inputs": [
        {
          "name": "oldAddr",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newAddr",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "FraudProofVerifierUpdated",
      "inputs": [
        {
          "name": "oldAddr",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newAddr",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "GuardianSlashSkipped",
      "inputs": [
        {
          "name": "fraudProofId",
          "type": "uint256",
          "indexed": true,
          "internalType": "uint256"
        },
        {
          "name": "guardian",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "GuardianSlashed",
      "inputs": [
        {
          "name": "fraudProofId",
          "type": "uint256",
          "indexed": true,
          "internalType": "uint256"
        },
        {
          "name": "guardian",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OwnershipTransferred",
      "inputs": [
        {
          "name": "previousOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "PermissionlessBLSRegistrationSet",
      "inputs": [
        {
          "name": "enabled",
          "type": "bool",
          "indexed": false,
          "internalType": "bool"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ProposalExecuted",
      "inputs": [
        {
          "name": "proposalId",
          "type": "uint256",
          "indexed": true,
          "internalType": "uint256"
        },
        {
          "name": "target",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "callDataHash",
          "type": "bytes32",
          "indexed": false,
          "internalType": "bytes32"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ReputationEpochTriggered",
      "inputs": [
        {
          "name": "epoch",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        },
        {
          "name": "userCount",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "SignatureAggregated",
      "inputs": [
        {
          "name": "proposalId",
          "type": "uint256",
          "indexed": true,
          "internalType": "uint256"
        },
        {
          "name": "aggregatedSignature",
          "type": "bytes",
          "indexed": false,
          "internalType": "bytes"
        },
        {
          "name": "count",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "SlashConsensusReached",
      "inputs": [
        {
          "name": "proposalId",
          "type": "uint256",
          "indexed": true,
          "internalType": "uint256"
        },
        {
          "name": "slashLevel",
          "type": "uint8",
          "indexed": false,
          "internalType": "uint8"
        },
        {
          "name": "requiredThreshold",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        },
        {
          "name": "evidenceHash",
          "type": "bytes32",
          "indexed": false,
          "internalType": "bytes32"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "SlashExecuted",
      "inputs": [
        {
          "name": "proposalId",
          "type": "uint256",
          "indexed": true,
          "internalType": "uint256"
        },
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "level",
          "type": "uint8",
          "indexed": false,
          "internalType": "uint8"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "SlashPolicyAdminUpdated",
      "inputs": [
        {
          "name": "oldAdmin",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newAdmin",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "SlashPreQueued",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "slashLevel",
          "type": "uint8",
          "indexed": false,
          "internalType": "uint8"
        },
        {
          "name": "epoch",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        },
        {
          "name": "requiredThreshold",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "SlashThresholdUpdated",
      "inputs": [
        {
          "name": "slashLevel",
          "type": "uint8",
          "indexed": true,
          "internalType": "uint8"
        },
        {
          "name": "oldThreshold",
          "type": "uint8",
          "indexed": false,
          "internalType": "uint8"
        },
        {
          "name": "newThreshold",
          "type": "uint8",
          "indexed": false,
          "internalType": "uint8"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "SuperPaymasterUpdated",
      "inputs": [
        {
          "name": "oldAddr",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newAddr",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ThresholdUpdated",
      "inputs": [
        {
          "name": "oldThreshold",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        },
        {
          "name": "newThreshold",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "error",
      "name": "EmptyGuiltyGuardians",
      "inputs": []
    },
    {
      "type": "error",
      "name": "EmptySignerMask",
      "inputs": []
    },
    {
      "type": "error",
      "name": "ForbiddenGenericSelector",
      "inputs": [
        {
          "name": "selector",
          "type": "bytes4",
          "internalType": "bytes4"
        }
      ]
    },
    {
      "type": "error",
      "name": "FraudProofVerifierNotSet",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidAddress",
      "inputs": [
        {
          "name": "addr",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "InvalidBLSKey",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidBLSKeyNotInSubgroup",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidBLSKeyNotOnCurve",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidFraudProof",
      "inputs": [
        {
          "name": "fraudProofId",
          "type": "uint256",
          "internalType": "uint256"
        }
      ]
    },
    {
      "type": "error",
      "name": "InvalidParameter",
      "inputs": [
        {
          "name": "message",
          "type": "string",
          "internalType": "string"
        }
      ]
    },
    {
      "type": "error",
      "name": "InvalidPoP",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidProposalId",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidSignatureCount",
      "inputs": [
        {
          "name": "count",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "required",
          "type": "uint256",
          "internalType": "uint256"
        }
      ]
    },
    {
      "type": "error",
      "name": "InvalidTarget",
      "inputs": [
        {
          "name": "target",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "KeyNotActive",
      "inputs": [
        {
          "name": "v",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "NotSlashPolicyAdmin",
      "inputs": [
        {
          "name": "caller",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "OwnableInvalidOwner",
      "inputs": [
        {
          "name": "owner",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "OwnableUnauthorizedAccount",
      "inputs": [
        {
          "name": "account",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "PermissionlessRegistrationDisabled",
      "inputs": []
    },
    {
      "type": "error",
      "name": "ProposalAlreadyExecuted",
      "inputs": [
        {
          "name": "proposalId",
          "type": "uint256",
          "internalType": "uint256"
        }
      ]
    },
    {
      "type": "error",
      "name": "ProposalExecutionFailed",
      "inputs": [
        {
          "name": "proposalId",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "returnData",
          "type": "bytes",
          "internalType": "bytes"
        }
      ]
    },
    {
      "type": "error",
      "name": "ReentrancyGuardReentrantCall",
      "inputs": []
    },
    {
      "type": "error",
      "name": "SignatureVerificationFailed",
      "inputs": []
    },
    {
      "type": "error",
      "name": "SlashQueueProofAlreadyUsed",
      "inputs": [
        {
          "name": "queueHash",
          "type": "bytes32",
          "internalType": "bytes32"
        }
      ]
    },
    {
      "type": "error",
      "name": "SlashThresholdOutOfRange",
      "inputs": [
        {
          "name": "threshold",
          "type": "uint8",
          "internalType": "uint8"
        }
      ]
    },
    {
      "type": "error",
      "name": "SlotAlreadyTaken",
      "inputs": [
        {
          "name": "slot",
          "type": "uint8",
          "internalType": "uint8"
        }
      ]
    },
    {
      "type": "error",
      "name": "SlotOutOfRange",
      "inputs": [
        {
          "name": "slot",
          "type": "uint8",
          "internalType": "uint8"
        }
      ]
    },
    {
      "type": "error",
      "name": "SlotValidatorRoleRevoked",
      "inputs": [
        {
          "name": "slot",
          "type": "uint8",
          "internalType": "uint8"
        },
        {
          "name": "v",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "SlotValidatorStakeBelowMinimum",
      "inputs": [
        {
          "name": "slot",
          "type": "uint8",
          "internalType": "uint8"
        },
        {
          "name": "v",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "actual",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "required",
          "type": "uint256",
          "internalType": "uint256"
        }
      ]
    },
    {
      "type": "error",
      "name": "StakingNotConfigured",
      "inputs": []
    },
    {
      "type": "error",
      "name": "UnauthorizedCaller",
      "inputs": [
        {
          "name": "caller",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "UnknownValidatorSlot",
      "inputs": [
        {
          "name": "slot",
          "type": "uint8",
          "internalType": "uint8"
        }
      ]
    }
  ]
}